import React, { useEffect, useState } from "react";
import LavorisService from "../../services/LavorisService";
import { TableActions } from "../../components/others/TableActions";
import { useSearchParams } from "react-router-dom";
import { useModal } from "../../hooks";
import { DetailTurnWithDate } from "../others/detailsTurn";
import moment from "moment";
import { filterMoldeExamPractice } from "../../utils/filterMoldeExamPractice";
import { useSelector } from "react-redux";
import { RootState } from "../../store/combineReducer";
import { useAlert } from "../../hooks/useAlert";
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { appointmentStatus } from "../../utils/appointmentStatus";
import { extractPracticesFromMetadata } from "../../utils/metadata";
import { handleOpenPdfReportPractice } from "../../utils/files";
import { TEmployeeApplicantPatient } from "../Turnos/Turnos.type";
import EditPrestadorTurn from "../others/editTurn/editTurnPrestador";
import EditTurn from "../others/editTurn";
import EliminarModal from "../../components/others/EliminarModal";
import RequestTurnsEmployeesInLavoris from "./requestTurnsEmployeesInLavoris";
import { Badge, BadgeProps } from "@mui/material";
import exelReports from "../Results/exelReports";
import InfoOffcanvas from "../../components/others/InfoOffCanvas/InfoOffCanvas";
import InfiniteTable from "../../components/others/InfiniteTableComponent/IntiniteTableComponent";
import { SuccessModal } from "../../components/others/SuccessModal";
import "./absence.scss";

const VIEW_APPOINTMENTS_MODAL = "viewAppointmentsModal";
const REQUEST_ABSENTEE_IN_LAVORIS_MODAL = "requesAbsenteeInLavorisModal";
const SUCCESS = 'succesPetition';

const AbsenceInLavoris = () => {
    const reduxStore = useSelector((state: RootState) => state.user);
    const chosenRole: string = reduxStore?.currentRole;
    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0]; // YYYY-MM-DD
    const maxDate = "9999-12-31";
    const [from, setFrom] = useState<string>(formattedToday);
    const [to, setTo] = useState<string>(maxDate);
    const [fromFormatted, setFromFormatted] = useState<string>(moment().format('DD/MM/YYYY'));
    const [toFormatted, setToFormatted] = useState<string>(moment().add(365, 'days').format('DD/MM/YYYY'));
    const [hasMore, setHasMore] = useState(true);
    const [searchQuery, setSearcQuery] = useState<string | null>(null);
    const hasSearchQuery = searchQuery && searchQuery.length > 0
    const LavorisInstance = LavorisService.getInstance();
    const currentCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0].id);
    const { closeModal, openModal, isActive } = useModal();
    const { showAlert } = useAlert();
    const [items, setItems] = useState({
        itemsPerPage: 20,
        page: 1,
    });

    const [data, setData] = useState<any[]>([]);
    const [loader, setLoader] = useState(false);
    const [chosenAppointment, setChosenAppointment] = useState<TEmployeeApplicantPatient>();
    const status = ['Solicitado', 'Pendiente de confirmación', 'Confirmado', 'Presente en Lavoris', 'Finalizado', 'Retirado']
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [searchParams, setSearchParams] = useSearchParams("");
    const controller = new AbortController();
    const signal = controller.signal;

    //GET ALL APPOINTMENTS FOR TABLE
    const getAllAppointmentsCall = async () => {
        setLoader(true);
        try {
            const app = await LavorisInstance.TurnServices.getAppointmentsWithSearchQueryByCompaniesIdInLavoris(currentCompany, items.itemsPerPage, items.page, fromFormatted, toFormatted, signal, hasSearchQuery ? searchQuery : "", status)


            if (app?.length === 0) {
                setHasMore(false);
                return;
            }
            // Obtén los IDs de las citas actuales en el estado
            const existingIds = new Set(data?.map(item => item.id));

            // Filtra las nuevas citas para agregar solo las que no están en el estado actual
            const uniqueAppointments = app?.filter(appointment => !existingIds.has(appointment.id));

            // Agrega nuevos app al estado existente
            setData(prevData => {
                return [...prevData, ...uniqueAppointments];
            });
            //Incrementa la página
            setItems(prev => ({ ...prev, page: prev.page + 1 }));
        } catch (e) {
            console.log(e);
            setHasMore(false);

        } finally {
            setLoader(false);
        }
    };

    const getAllAppointmentsCallRefresh = async () => {
        setLoader(true);
        try {
            const app = await LavorisInstance.TurnServices.getAppointmentsWithSearchQueryByCompaniesIdInLavoris(currentCompany, items.itemsPerPage, items.page, fromFormatted, toFormatted, signal, hasSearchQuery ? searchQuery : "", status)


            if (app?.length === 0) {
                //showAlert("No se encontraron registros");
                setHasMore(false);
                return;
            }

            setData([])
            setData(app)
            //Incrementa la página
            setItems(prev => ({ ...prev, page: prev.page + 1 }));
        } catch (e) {
            console.log(e);
            setHasMore(false);

        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        getAllAppointmentsCall();
    }, [])

    useEffect(() => {
        return () => {
            controller.abort()
        };
    }, [])

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const querySearch = e.target.value;
        setSearcQuery(querySearch);
    }

    const searchWithDatesOnly = async () => {
        setLoader(true);
        try {
            setItems(prev => ({ ...prev, page: 1 }));
            let app = await LavorisInstance.TurnServices.getAppointmentsWithSearchQueryByCompaniesIdInLavoris(currentCompany, items.itemsPerPage, 1, fromFormatted, toFormatted, signal, "", status)
            setData([])
            if (app?.length === 0) {
                showAlert("No se encontraron registros");
                return
            } else {
                setData(app);
                setItems(prev => ({ ...prev, page: prev.page + 1 }));
                setHasMore(true);
            }

        } catch (error) {
            console.log(error);
            setHasMore(false);
        } finally {
            setLoader(false);
        }
    }

    const searchWitQuery = async () => {
        setLoader(true);
        try {
            let app = await LavorisInstance.TurnServices.getAppointmentsWithSearchQueryByCompaniesIdInLavoris(currentCompany, items.itemsPerPage, 1, fromFormatted, toFormatted, signal, searchQuery, status)
            setData([])
            if (app?.length === 0) {
                showAlert("No se encontraron registros");
                return
            } else {
                setData(app);
                setItems(prev => ({ ...prev, page: prev.page + 1 }));
                setHasMore(true);
            }

        } catch (error) {
            console.log(error);
            setHasMore(false);
        } finally {
            setLoader(false);
        }
    }

    const onSearch = async () => {
        try {
            if (hasSearchQuery) {
                await searchWitQuery()
            } else {
                await searchWithDatesOnly()
            }

        } catch (error) {
            console.log(error);
        }
    };

    const HandleDeletion = async () => {
        setIsLoading(true);
        setItems({
            itemsPerPage: 20,
            page: 1,
        });
        try {
            let turnID: any = searchParams.get("rowId");
            await LavorisInstance.TurnServices.DeleteTurn(turnID);
            closeModal("EliminateModal");
            setData([])
            getAllAppointmentsCallRefresh();

        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);

        }
    };

    const handleFromDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const dateValue = e.target.value;
        setFrom(dateValue); // Mantiene el valor en formato 'YYYY-MM-DD' para el input
        setFromFormatted(moment(dateValue).format('DD/MM/YYYY')); // Guarda en formato 'DD/MM/YYYY' para procesarlo
    };

    const handleToDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const dateValue = e.target.value;
        setTo(dateValue); // Mantiene el valor en formato 'YYYY-MM-DD' para el input
        setToFormatted(moment(dateValue).format('DD/MM/YYYY')); // Guarda en formato 'DD/MM/YYYY' para procesarlo
    };

    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 220,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }));

    const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
        '& .MuiBadge-badge': {
            right: -3,
            top: 13,
            border: `2px solid ${theme.palette.background.paper}`,
            padding: '0 4px',
            margin: '0  4px'
        },
    }));

    useEffect(() => {
        data?.sort((a, b) => {
            // Colocar los turnos con estado "Solicitado" primero
            if (a?.status === "Solicitado" && b?.status !== "Solicitado") {
                return -1; // a va antes que b
            }
            if (a?.status !== "Solicitado" && b?.status === "Solicitado") {
                return 1; // b va antes que a
            }

            // Si ambos tienen el mismo estado que no es "Solicitado", o ninguno es "Solicitado"
            const dateA = new Date(a?.date?.split('/').reverse().join('-')); // Convierte 'dd/MM/yyyy' a 'yyyy-MM-dd'
            const dateB = new Date(b?.date?.split('/').reverse().join('-'));

            if (dateA?.getTime() === dateB?.getTime()) {
                // Si las fechas son iguales, ordenar por la hora en orden descendente
                const timeA = a?.startTime?.split(':').map(Number); // Convierte 'HH:mm' en un array de números
                const timeB = b?.startTime?.split(':').map(Number);
                return timeB[0] - timeA[0] || timeB[1] - timeA[1]; // Ordena en orden descendente por horas y minutos
            }

            return dateB.getTime() - dateA.getTime(); // Comparar fechas en orden descendente
        });

    }, [data]);

    const giaSolicitud = (row: any) => {
        if (!row) return '---'
        const gia = row?.gia ? 'Si' : 'No'
        return (
            <p className={`${row.gia ? 'text-green-700' : 'text-red-700'} font-extrabold`}>{gia} </p>
        )
    }

    const actionResult = (row: any) => {

        const hasOnlyIsolatedPractices = (row: any) => {
            const practices = extractPracticesFromMetadata(row.metadata);
            if (!practices) return false;

            return practices.every((p: any) => p.type === "PRACTICE" || p.type === 'PRACTICE_IN_MOLDE');
        };

        const downloadSequentiallyPDFs = async (row: any) => {
            const practices = extractPracticesFromMetadata(row?.metadata);
            const patient = row?.metadata?.patient?.name || 
                row?.patient?.employee?.user?.name || 
                row?.patient?.candidate?.user?.name || 
                row?.patient?.particularClient?.user?.name;
            if (!practices) return false;

            for (const p of practices) {
                await handleOpenPdfReportPractice((p as any).pdfUrl, p.name, patient);
            }
        };
        let apptStatus =
            (
                <div className="flex justify-center">
                    {hasOnlyIsolatedPractices(row) && (
                        <>
                            <TableActions
                                type="Download"
                                title="Descargar PDF"
                                onClick={() => downloadSequentiallyPDFs(row)}
                            />

                        </>
                    )}
                </div>
            );
        return apptStatus
    }

    return (
        <div className="absence-module-container">
            <div className="custom-header mt-4 pt-2">
                <div className="header-controls">
                    {/* Search Section */}
                    <div className="search-section">
                        <div className="search-input-group">
                            <div className="search-input-label-top">
                                <label htmlFor="search-dni">Buscar por DNI o Apellido</label>
                                <input
                                    title="Ingresar dni o apellido"
                                    type="search"
                                    placeholder="Ingresa un DNI o Apellido"
                                    className="search-input"
                                    onChange={handleSearchChange}
                                />
                            </div>
                            <div className="search-input-label-top">
                                <label htmlFor="search-date-from">Desde</label>
                                <input
                                    title="Desde"
                                    type="date"
                                    value={from ?? ""}
                                    placeholder="Desde"
                                    className="search-input"
                                    onChange={handleFromDateChange}
                                />
                            </div>
                            <div className="search-input-label-top">
                                <label htmlFor="search-date-to">Hasta</label>
                                <input
                                    title="Hasta"
                                    type="date"
                                    value={to ?? ""}
                                    placeholder="Hasta"
                                    className="search-input"
                                    onChange={handleToDateChange}
                                />
                            </div>
                            <button
                                type="button"
                                className="search-btn"
                                onClick={() => {
                                    onSearch()
                                }}
                                title="Buscar"
                            >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path
                                        d="M7.333 12.667A5.333 5.333 0 1 0 7.333 2a5.333 5.333 0 0 0 0 10.667ZM14 14l-2.9-2.9"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>

                    {/* Actions Section */}
                    <div className="actions-section">
                        <div className="results-count d-inline-flex">
                            <span className="count-number">{data.length}</span>
                            <span className="count-label">items</span>
                        </div>

                        {!loader && (<>
                            <button
                                type="button"
                                className="add-btn"
                                onClick={() => {
                                    setItems({
                                        itemsPerPage: 20,
                                        page: 1,
                                    });
                                    openModal(REQUEST_ABSENTEE_IN_LAVORIS_MODAL);
                                }}
                                title="Solicitar consultorio"
                            >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path
                                        d="M8 3.333v9.334M3.333 8h9.334"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <span className="btn-text">Solicitar</span>
                            </button>

                            <button
                                className="download-btn"
                                onClick={() => exelReports(data, false)}
                                title="Descargar reporte de todos los postulantes"
                                disabled={data.length === 0}
                            >

                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path
                                        d="M14 10v2.667A1.333 1.333 0 0112.667 14H3.333A1.333 1.333 0 012 12.667V10M8 10.667L8 2M8 10.667l-2.667-2.666M8 10.667l2.667-2.666"
                                        stroke="currentColor"
                                        strokeWidth="1.3"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>

                                <span className="btn-text">Excel</span>
                            </button>
                        </>

                        )}


                        <InfoOffcanvas title="INFORMACIÓN DE BÚSQUEDA">
                            <ul className="text-md p-auto m-auto">
                                <li>- Se puede búscar solo con fechas.</li>
                                <li>- Si se búsca con apellido, nombre o dni y no se filtra por fecha</li>
                                <li>- Las fechas del filtro se pueden poner manualmente.</li>
                                <li>- A medida que se va haciendo scroll para abajo, la tabla va buscando más resultados.</li>
                            </ul>
                        </InfoOffcanvas>

                    </div>
                </div>
            </div>

            <InfiniteTable
                data={data}
                columns={[
                    {
                        key: 'patientName',
                        title: 'Apellido y Nombre',
                        className: 'col-name',
                        render: (value: any, row: any) =>
                            row?.metadata?.patient?.name?.toUpperCase() || row?.patient?.name?.toUpperCase() || row?.patient?.employee?.user?.name?.toUpperCase() || "---"
                    },
                    {
                        key: 'dni',
                        title: 'DNI',
                        className: 'col-dni',
                        render: (value: any, row: any) =>
                            row?.metadata?.patient?.dni || row?.patient?.DNI || row?.patient?.employee?.user?.DNI || "---"
                    },
                    {
                        key: 'fecha',
                        title: 'Fecha de solicitud',
                        className: 'col-fecha-turno',
                        render: (value: any, row: any) =>
                            moment(row.createdDate).format('DD/MM/YY HH:mm') || "---"
                    },
                    {
                        key: 'gia',
                        title: 'AI',
                        className: 'col-gia',
                        render: (value: any, row: any) =>
                            giaSolicitud(row) || "No disponible"
                    },
                    {
                        key: 'fecha_turno',
                        title: 'Fecha y hora del turno',
                        className: 'col-fecha-turno',
                        render: (value: any, row: any) =>
                            row?.date && row?.startTime ? `${row?.date} - ${row?.startTime}` : "---"
                    },
                    {
                        key: 'fecha_admicion',
                        title: 'Fecha y hora de admisión',
                        className: 'col-fecha-turno',
                        render: (value: any, row: any) =>
                            row?.admissionTime ? row?.admissionTime : '---'
                    },
                    {
                        key: 'status',
                        title: 'Estado',
                        className: 'col-fecha-turno',
                        render: (value: any, row: any) =>
                            appointmentStatus(row)
                    },
                    {
                        key: 'diagnostic',
                        title: 'Descripción',
                        className: 'col-diagnostic',
                        render: (value: any, row: any) => filterMoldeExamPractice(row) || "---"
                    },
                    {
                        key: 'actions',
                        title: 'Acciones',
                        className: 'col-actions',
                        render: (value: any, row: any) => (
                            <div className="flex flex-wrap gap-2 justify-center">
                                <TableActions
                                    type="View"
                                    onClick={() =>
                                        openModal(VIEW_APPOINTMENTS_MODAL, row.id)
                                    }
                                />
                                {(row?.status === 'Finalizado' && chosenRole !== "RRHH_APPOINTMENTS_AND_ABSENTEE") && (
                                    actionResult(row)
                                )}
                                {
                                    row?.status === 'Solicitado' && (
                                        <>
                                            <TableActions
                                                type="Edit"
                                                onClick={() => {
                                                    setItems({
                                                        itemsPerPage: 20,
                                                        page: 1,
                                                    });

                                                    setChosenAppointment(row.patient);
                                                    row.is_prestador ? openModal("modalEditPrestadorTurn", row.id) : openModal("modalEditTurn", row.id);
                                                }}
                                            />

                                            <TableActions
                                                type="Delete"
                                                onClick={() => {
                                                    setItems({
                                                        itemsPerPage: 20,
                                                        page: 1,
                                                    });

                                                    setChosenAppointment(row.patient);
                                                    openModal("EliminateModal", row.id);
                                                }}
                                            />

                                        </>
                                    )
                                }
                            </div>
                        )
                    }
                ]}
                loading={loader}
                hasMore={hasMore}
                onLoadMore={getAllAppointmentsCall}
                height={400}
            />

            {isActive(VIEW_APPOINTMENTS_MODAL) && (
                <DetailTurnWithDate
                    show
                    modalTitle={"Detalle de turno"}
                    urlTittle={VIEW_APPOINTMENTS_MODAL}
                    closeModal={() => closeModal(VIEW_APPOINTMENTS_MODAL)}
                />
            )}

            {isActive("modalEditPrestadorTurn") && (
                <EditPrestadorTurn
                    toggleModal
                    urlTittle={"modalEditPrestadorTurn"}
                    patient={chosenAppointment}
                    onClose={() => closeModal("modalEditPrestadorTurn")}
                    isApplicant={chosenAppointment?.type === 'CANDIDATE' ? true : false}
                    refreshFunction={() => {
                        closeModal("modalEditPrestadorTurn")
                        getAllAppointmentsCallRefresh()
                    }}
                />
            )}

            {isActive("modalEditTurn") && (
                <EditTurn
                    toggleModal
                    urlTittle={"modalEditTurn"}
                    patient={chosenAppointment}
                    refreshFunction={() => {
                        closeModal("modalEditTurn")
                        getAllAppointmentsCallRefresh()
                    }}
                    onClose={() => closeModal("modalEditTurn")}
                    isApplicant={chosenAppointment?.type === 'CANDIDATE' ? true : false}
                />
            )}

            {isActive("EliminateModal") && (
                <EliminarModal
                    toggleModal={true}
                    name={chosenAppointment?.name || ""}
                    isLoading={isLoading}
                    handleDeletion={HandleDeletion}
                    urlTittle={"EliminateModal"}
                    onClose={() => closeModal("EliminateModal")}
                />
            )}

            {isActive(REQUEST_ABSENTEE_IN_LAVORIS_MODAL) && (
                <RequestTurnsEmployeesInLavoris
                    show
                    modalTitle='Solicitar Turno'
                    urlTittle={REQUEST_ABSENTEE_IN_LAVORIS_MODAL}
                    onClose={() => closeModal(REQUEST_ABSENTEE_IN_LAVORIS_MODAL)}
                    refreshFunction={() => {
                        closeModal(REQUEST_ABSENTEE_IN_LAVORIS_MODAL)
                        getAllAppointmentsCallRefresh()
                    }}

                />
            )}

            {isActive(SUCCESS) && (
                <SuccessModal
                    show
                    urlTittle={SUCCESS}
                    modalTitle={'SOLICITUD CREADA EXITOSAMENTE.'}
                    modalSubtitle={''}
                    onClose={() => { closeModal(SUCCESS) }}
                />
            )}
        </div>
    )
};

export default AbsenceInLavoris;